export enum ServiceStatusDTO {
    Unseated = 'UNSEATED',
    Drinks = 'DRINKS',
    Starter = 'STARTER',
    Main = 'MAIN',
    Dessert = 'DESSERT',
    Bill = 'BILL',
    Cleaning = 'CLEANING',
    Paid = 'PAID',
    Closed = 'CLOSED',
}
